import {type LexiconDoc} from '@atproto/lexicon'

import {getSuggestedOnboardingUsers} from './getSuggestedOnboardingUsers'
import {listNotifications} from './listNotifications'
import {putLearnerLevel} from './putLearnerLevel'
import {putOnboardingData} from './putOnboardingData'
import {recordFeedEvents} from './recordFeedEvents'

export type CustomLexiconEntry = {
  /** When true, any existing SDK registration is removed before adding. */
  override?: boolean
  doc: LexiconDoc
}

/**
 * Custom lexicon overrides registered on the agent at startup.
 * Add a new file to this folder, export its LexiconDoc, then import it here.
 * Set override: true for lexicons that the SDK already registers (to replace them).
 */
export const customLexicons: CustomLexiconEntry[] = [
  {doc: putOnboardingData},
  {doc: putLearnerLevel},
  {doc: getSuggestedOnboardingUsers, override: true},
  {doc: listNotifications, override: true},
  {doc: recordFeedEvents},
]
